// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/governance/v0/merchant_data.proto (package squareup.governance.v0, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/common/governance/v0/merchant_data.proto.
 */
export const file_squareup_common_governance_v0_merchant_data: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message squareup.governance.v0.MerchantData
 */
export type MerchantData = Message<"squareup.governance.v0.MerchantData"> & {
};

/**
 * Describes the message squareup.governance.v0.MerchantData.
 * Use `create(MerchantDataSchema)` to create a new message.
 */
export const MerchantDataSchema: GenMessage<MerchantData> = /*@__PURE__*/
  messageDesc(file_squareup_common_governance_v0_merchant_data, 0);

/**
 * @generated from enum squareup.governance.v0.MerchantData.SemanticType
 */
export enum MerchantData_SemanticType {
  /**
   * @generated from enum value: DO_NOT_USE = 0;
   */
  DO_NOT_USE = 0,

  /**
   * Facial images used for identity verification, such as on a photo of a Government ID document.
   *
   * @generated from enum value: GOV_ID_FACIAL_IMAGE = 1;
   */
  GOV_ID_FACIAL_IMAGE = 1,

  /**
   * Seller's voiceprint.
   *
   * @generated from enum value: VOICEPRINT = 2;
   */
  VOICEPRINT = 2,

  /**
   * Seller's fignerprint.
   *
   * @generated from enum value: FINGERPRINT = 3;
   */
  FINGERPRINT = 3,

  /**
   * Handwriting, including a handwritten signature, such as on a photo of a Government ID document.
   *
   * @generated from enum value: HANDWRITING = 4;
   */
  HANDWRITING = 4,

  /**
   * A seller's full name.
   *
   * @generated from enum value: FULL_NAME = 5;
   */
  FULL_NAME = 5,

  /**
   * A seller's personal email address (including hashed email address).
   *
   * @generated from enum value: EMAIL_ADDRESS = 6;
   */
  EMAIL_ADDRESS = 6,

  /**
   * The seller's full residential postal address.
   *
   * @generated from enum value: RESIDENTIAL_ADDRESS = 7;
   */
  RESIDENTIAL_ADDRESS = 7,

  /**
   * A seller's personal phone number (including hashed phone number): seven (7) digits or more.
   *
   * @generated from enum value: PHONE_NUMBER = 8;
   */
  PHONE_NUMBER = 8,

  /**
   * Username, $Cashtag, social media handle.
   *
   * @generated from enum value: USERNAME = 9;
   */
  USERNAME = 9,

  /**
   * Bank account number.
   *
   * @generated from enum value: BANK_ACCOUNT_NUMBER = 10;
   */
  BANK_ACCOUNT_NUMBER = 10,

  /**
   * Payment Card Primary Account Number (PAN) (more than defined by COARSE_PAYMENT_CARD_PAN).
   *
   * @generated from enum value: PAYMENT_CARD_PAN = 11;
   */
  PAYMENT_CARD_PAN = 11,

  /**
   * Social Security Number (SSN).
   *
   * @generated from enum value: SSN = 12;
   */
  SSN = 12,

  /**
   * Employer Identification Number (EIN).
   *
   * @generated from enum value: EIN = 13;
   */
  EIN = 13,

  /**
   * Passport Number.
   *
   * @generated from enum value: PASSPORT_NUMBER = 14;
   */
  PASSPORT_NUMBER = 14,

  /**
   * Driver's License Number.
   *
   * @generated from enum value: DRIVERS_LICENSE_NUMBER = 15;
   */
  DRIVERS_LICENSE_NUMBER = 15,

  /**
   * Individual Tax ID Number (ITIN).
   *
   * @generated from enum value: ITIN = 16;
   */
  ITIN = 16,

  /**
   * Authentication tokens and session tokens.
   *
   * @generated from enum value: AUTH_TOKEN = 17;
   */
  AUTH_TOKEN = 17,

  /**
   * Passwords/passcodes.
   *
   * @generated from enum value: PASSWORD = 18;
   */
  PASSWORD = 18,

  /**
   * Security questions and answers.
   *
   * @generated from enum value: SECURITY_QUESTION_ANSWER = 19;
   */
  SECURITY_QUESTION_ANSWER = 19,

  /**
   * Plaid tokens and similar access credentials for Seller's bank accounts.
   *
   * @generated from enum value: BANK_ACCESS_TOKEN = 20;
   */
  BANK_ACCESS_TOKEN = 20,

  /**
   * A first name of a seller.
   *
   * @generated from enum value: FIRST_NAME = 21;
   */
  FIRST_NAME = 21,

  /**
   * A middle name or middle initial of a seller.
   *
   * @generated from enum value: MIDDLE_NAME = 22;
   */
  MIDDLE_NAME = 22,

  /**
   * A last name of a seller (surname).
   *
   * @generated from enum value: LAST_NAME = 23;
   */
  LAST_NAME = 23,

  /**
   * The street name and street number of a seller' residence, including any additional information about unit/apt/suite/etc.
   *
   * @generated from enum value: STREET_OF_RESIDENCE = 24;
   */
  STREET_OF_RESIDENCE = 24,

  /**
   * Residential ZIP/postal code.
   *
   * @generated from enum value: POSTAL_CODE_OF_RESIDENCE = 25;
   */
  POSTAL_CODE_OF_RESIDENCE = 25,

  /**
   * City of residence.
   *
   * @generated from enum value: CITY_OF_RESIDENCE = 26;
   */
  CITY_OF_RESIDENCE = 26,

  /**
   * State/Region/Province/County of residence.
   *
   * @generated from enum value: REGION_OF_RESIDENCE = 27;
   */
  REGION_OF_RESIDENCE = 27,

  /**
   * Country of residence.
   *
   * @generated from enum value: COUNTRY_OF_RESIDENCE = 28;
   */
  COUNTRY_OF_RESIDENCE = 28,

  /**
   * Personal phone number: up to six (6) digits.
   *
   * @generated from enum value: COARSE_PHONE_NUMBER = 29;
   */
  COARSE_PHONE_NUMBER = 29,

  /**
   * Seller's device IDs (including Advertising ID and other unique identifiers that corresponds with an individual's mobile device).
   *
   * @generated from enum value: DEVICE_ID = 30;
   */
  DEVICE_ID = 30,

  /**
   * A seller's full date of birth.
   *
   * @generated from enum value: DATE_OF_BIRTH = 31;
   */
  DATE_OF_BIRTH = 31,

  /**
   * The day of the month a seller was born.
   *
   * @generated from enum value: BIRTH_DAY_OF_MONTH = 32;
   */
  BIRTH_DAY_OF_MONTH = 32,

  /**
   * The month a seller was born.
   *
   * @generated from enum value: BIRTH_MONTH = 33;
   */
  BIRTH_MONTH = 33,

  /**
   * The year a seller was born.
   *
   * @generated from enum value: BIRTH_YEAR = 34;
   */
  BIRTH_YEAR = 34,

  /**
   * Gender.
   *
   * @generated from enum value: GENDER = 35;
   */
  GENDER = 35,

  /**
   * Personal inferences about the Seller.
   *
   * @generated from enum value: INFERENCES = 36;
   */
  INFERENCES = 36,

  /**
   * Customer ID (of a Seller).
   *
   * @generated from enum value: CUSTOMER_ID = 37;
   */
  CUSTOMER_ID = 37,

  /**
   * Information pertaining to a seller's religious beliefs, philosophical beliefs, or union membership.
   *
   * @generated from enum value: BELIEFS_OR_POLITICS = 38;
   */
  BELIEFS_OR_POLITICS = 38,

  /**
   * Information pertaining to a seller's health, sex life, or sexual orientation.
   *
   * @generated from enum value: HEALTH_OR_SEXUALITY = 39;
   */
  HEALTH_OR_SEXUALITY = 39,

  /**
   * Information about a seller's racial or ethnic demographic.
   *
   * @generated from enum value: ETHNICITY_OR_RACE = 40;
   */
  ETHNICITY_OR_RACE = 40,

  /**
   * Touch events on mobile devices. NOTE: individual touch events are quasi-identifiers and should be regarded as pseudonymous, de-identified data by themselves. Sequences of touch events should be considered as equivalent to the data they represent (e.g., touch event sequences for customer identifiers or authentication efforts should be regarded as identifiable and possibly sensitive).
   *
   * @generated from enum value: TOUCH_EVENTS = 41;
   */
  TOUCH_EVENTS = 41,

  /**
   * Seller's bank name.
   *
   * @generated from enum value: BANK_NAME = 42;
   */
  BANK_NAME = 42,

  /**
   * Seller's bank routing number.
   *
   * @generated from enum value: BANK_ROUTING_NUMBER = 43;
   */
  BANK_ROUTING_NUMBER = 43,

  /**
   * Bank account number (coarse): maximum of four (4) digits.
   *
   * @generated from enum value: COARSE_BANK_ACCOUNT_NUMBER = 44;
   */
  COARSE_BANK_ACCOUNT_NUMBER = 44,

  /**
   * Coarse Credit Card Primary Account Number (PAN): BIN or last four digits (max ten digits).
   *
   * @generated from enum value: COARSE_PAYMENT_CARD_PAN = 45;
   */
  COARSE_PAYMENT_CARD_PAN = 45,

  /**
   * A seller's credit score (e.g., FICO).
   *
   * @generated from enum value: CREDIT_SCORE = 46;
   */
  CREDIT_SCORE = 46,

  /**
   * Date of Transaction (e.g. a bank deposit, a purchase, etc.)
   *
   * @generated from enum value: TRANSACTION_DATE = 47 [deprecated = true];
   * @deprecated
   */
  TRANSACTION_DATE = 47,

  /**
   * Amount of Transaction (e.g. a bank deposit, a purchase, etc.)
   *
   * @generated from enum value: TRANSACTION_AMOUNT = 48 [deprecated = true];
   * @deprecated
   */
  TRANSACTION_AMOUNT = 48,

  /**
   * Sender/Recipient/Merchant of Transaction (e.g. a bank deposit, a purchase, etc.)
   *
   * @generated from enum value: TRANSACTION_PARTY = 49 [deprecated = true];
   * @deprecated
   */
  TRANSACTION_PARTY = 49,

  /**
   * Last four (4) digits of a seller's Social Security Number (SSN).
   *
   * @generated from enum value: COARSE_SSN = 50;
   */
  COARSE_SSN = 50,

  /**
   * Geolocation (precise): location data with a resolution the same or greater than latitude and longitude with three or more decimal places.
   *
   * @generated from enum value: PRECISE_GEOLOCATION = 51;
   */
  PRECISE_GEOLOCATION = 51,

  /**
   * Geolocation (coarse): location data with a resolution the same or less than latitude and longitude with two decimal places.
   *
   * @generated from enum value: COARSE_GEOLOCATION = 52;
   */
  COARSE_GEOLOCATION = 52,

  /**
   * Seller's IP Address.
   *
   * @generated from enum value: IP_ADDRESS = 53;
   */
  IP_ADDRESS = 53,

  /**
   * Free-form text fields and similar user-supplied application content (such as payment notes, email messages, text messages, voice transcripts, etc.), or customer support data generated by the user.
   *
   * @generated from enum value: USER_GENERATED_TEXT = 54;
   */
  USER_GENERATED_TEXT = 54,

  /**
   * Tokens used to identify a merchant customer, such as pseudonyms for Contact information, such as a Fidelius SSN/ITIN token.
   *
   * @generated from enum value: PERSON_PSEUDONYM = 55;
   */
  PERSON_PSEUDONYM = 55,

  /**
   * Tokens used to identify a specific financial instrument, such as a Fidelius PAN token or bank account token (note: this excludes tokens shared with third-parties to facilitate financial transactions).
   *
   * @generated from enum value: INSTRUMENT_PSEUDONYM = 56;
   */
  INSTRUMENT_PSEUDONYM = 56,

  /**
   * Tokens used to identify a particular device, such as a seller's phone, such as App Tokens.
   *
   * @generated from enum value: DEVICE_PSEUDONYM = 57;
   */
  DEVICE_PSEUDONYM = 57,

  /**
   * Seller's business zip/postal code.
   *
   * @generated from enum value: BUSINESS_POSTAL_CODE = 58;
   */
  BUSINESS_POSTAL_CODE = 58,

  /**
   * Seller's business name.
   *
   * @generated from enum value: BUSINESS_NAME = 59;
   */
  BUSINESS_NAME = 59,

  /**
   * Seller's business email address (including hashed email address).
   *
   * @generated from enum value: BUSINESS_EMAIL = 60;
   */
  BUSINESS_EMAIL = 60,

  /**
   * Seller's business postal address.
   *
   * @generated from enum value: BUSINESS_ADDRESS = 61;
   */
  BUSINESS_ADDRESS = 61,

  /**
   * Seller's business phone number (including hashed phone number).
   *
   * @generated from enum value: BUSINESS_PHONE_NUMBER = 62;
   */
  BUSINESS_PHONE_NUMBER = 62,

  /**
   * Seller's business social media handles.
   *
   * @generated from enum value: BUSINESS_USERNAME = 63;
   */
  BUSINESS_USERNAME = 63,

  /**
   * Such as a list of contacts in the user's phone, address book, or social graph (see the Contact Information (Precise) category).
   *
   * @generated from enum value: CONTACTS = 64;
   */
  CONTACTS = 64,

  /**
   * Information relating to a seller's personal income, such as salary, commission, investment income, etc.
   *
   * @generated from enum value: INCOME = 65;
   */
  INCOME = 65,

  /**
   * Information relating to a seller's personal expenses, such as mortgage/rental payments, monthly utilities, debt payments, etc.
   *
   * @generated from enum value: EXPENSES = 66;
   */
  EXPENSES = 66,

  /**
   * Information relating to a seller's personal assets, such as details on savings accounts, retirement funds, stocks, bonds, and investments.
   *
   * @generated from enum value: ASSETS = 67;
   */
  ASSETS = 67,

  /**
   * Underwriting decisions.
   *
   * @generated from enum value: UNDERWRITING = 68;
   */
  UNDERWRITING = 68,

  /**
   * Advertising data, such as information about the advertisements the Seller has seen.
   *
   * @generated from enum value: ADVERTISING_DATA = 69;
   */
  ADVERTISING_DATA = 69,

  /**
   * Transaction records (Sales / Purchases).
   *
   * @generated from enum value: TRANSACTION_RECORDS = 70;
   */
  TRANSACTION_RECORDS = 70,

  /**
   * Details on chargebacks including chargeback date, amount, reason, and any supporting documentation.
   *
   * @generated from enum value: CHARGEBACKS = 71;
   */
  CHARGEBACKS = 71,

  /**
   * Details regarding any refunds issued for a transaction including refund date, amount, and reason.
   *
   * @generated from enum value: REFUNDS = 72;
   */
  REFUNDS = 72,

  /**
   * Such as app launches, taps, scrolling information or other information about how the user interacts with the Square app.
   *
   * @generated from enum value: INTERACTIONS = 73;
   */
  INTERACTIONS = 73,

  /**
   * Payroll information.
   *
   * @generated from enum value: PAYROLL_INFORMATION = 74;
   */
  PAYROLL_INFORMATION = 74,

  /**
   * Tax forms (e.g., W-2, W-4).
   *
   * @generated from enum value: TAX_FORMS = 75;
   */
  TAX_FORMS = 75,

  /**
   * Dates and amounts deposited to Seller bank accounts.
   *
   * @generated from enum value: BANK_DEPOSIT_RECORD = 76;
   */
  BANK_DEPOSIT_RECORD = 76,
}

/**
 * Describes the enum squareup.governance.v0.MerchantData.SemanticType.
 */
export const MerchantData_SemanticTypeSchema: GenEnum<MerchantData_SemanticType> = /*@__PURE__*/
  enumDesc(file_squareup_common_governance_v0_merchant_data, 0, 0);

